import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
@Component({
  selector: 'data-privacy',
  templateUrl: './data-privacy.component.html',
  styleUrls: ['./data-privacy.component.less']
})
export class DataPrivacyMessage implements OnInit, OnDestroy {

  // 缓存后的隐私数据，避免 getter 在每次变更检测都返回新数组/新对象
  // 从而导致 *ngFor 销毁并重建 <tr>（含内部可点击的 <span class="link-text">）
  privacyData: any[] = [];

  get columns(): any[] {
    return [
      { key: 'subject', name: this.translate.instant('PRIVACY_SUBJECT'), visible: true,  width: '240px' },
      { key: 'purpose', name: this.translate.instant('PRIVACY_PURPOSE'), visible: true,  width: '300px' },
      { key: 'status', name: this.translate.instant('PRIVACY_STATUS'), visible: true },
      { key: 'time', name:this.translate.instant('PRIVACY_TIME'), visible: true,},
      { key: 'pperation', name: this.translate.instant('PRIVACY_OPERATION'), visible: true },
    ];
  }
  tableData: any[] = []
  private langChangeSub?: Subscription;

  constructor(
    private loginService:LoginService,
    private router: Router,
    private modal: NzModalService,
    private translate:TranslateService
  ) {}

  ngOnInit(): void {
    this.buildPrivacyData();
    this.getPrivacyList();
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.buildPrivacyData();
    });
  }

  ngOnDestroy(): void {
    this.langChangeSub?.unsubscribe();
  }

  // 基于 tableData 和当前语言构造稳定的行数据；只在数据源或语言变化时调用一次
  private buildPrivacyData(): void {
    const termsUse = this.tableData.find(i => i.privacyId === 2);
    const crossBorder = this.tableData.find(i => i.privacyId === 1);
    const privacyStatement = this.tableData.find(i => i.privacyId === 3);
    const country = localStorage.getItem("country");
    this.privacyData = [
      {
        subject: this.translate.instant('PRIVACY_TERMS_OF_USE'),
        purpose: this.translate.instant('AGREE_TERM1'),
        time: '',
        status: '',
        privacyId: 2,
        url: `${country}/myAccount/user-terms`,
        ...( termsUse|| {} )
      },
      {
        subject: this.translate.instant('PRIVACY_CROSS-BORDER'),
        purpose: this.translate.instant('AGREE_TERM2'),
        time: '',
        status: '',
        privacyId: 1,
        url: `${country}/myAccount/data-protection-policy`,
        ...( crossBorder|| {} )
      },
      {
        subject: this.translate.instant('PRIVACY_STATEMENT'),
        purpose: this.translate.instant('AGREE_TERM1'),
        time: '',
        status: '',
        privacyId: 3,
        url: `${country}/myAccount/data-protection-policy`,
        ...( privacyStatement|| {} )
      }
    ];
  }

  // *ngFor 的 trackBy，使用稳定的 privacyId 复用 DOM 节点
  trackByPrivacyId = (_index: number, item: any): number => item.privacyId;

   // get privacy agree list
   getPrivacyList(){
    this.loginService.getPrivacyList().subscribe(res => {
      this.tableData = res?.data || [];
      this.buildPrivacyData();
    })
  }

  revokePrivacy(data: any){
    const params = [
      {
        id: data.id,
        status: 0
      }
    ]
    this.loginService.updatePrivacy(params).subscribe(res => {
      this.loginService.sendAgreeStatus(true)
      this.router.navigate(['home/index']);
    })


  }

  handleViewPrivacy(url: string){
    this.router.navigate([url]);
  }
}
